import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    container:{
        marginLeft: '0px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    },
    blue: {
        color: '#0077CC'
    }
}));

export default useStyles;
